import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StepperWrapper } from '@/components/custom/stepper';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { FilterTitle } from '@/components/custom/filter';

export default function QuestionSidebar(props) {
  const { t } = useTranslation();
  const { steps, currentStep } = props;
  const location = useLocation();
  const backTo = location.state?.origin || '/avaliacoes/banco-de-questoes';

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack asChild>
        <Link to={backTo}>
          <IconWrapper>
            <FiChevronLeft />
          </IconWrapper>
          <ButtonBackContent>
            <FilterTitle>{t('textsCommon.questions')}</FilterTitle>
          </ButtonBackContent>
        </Link>
      </ButtonBack>

      <StepperWrapper
        steps={steps}
        currentStep={currentStep}
      />
    </DashboardSidebar>
  );
}
